<template>
  <div class="download-password-protected-media">
    <!-- Download Button -->
    <button class="button media__button" @click="openPasswordModal">
      {{ t.downloadFile }}
    </button>

    <!-- Password Modal Component -->
    <DownloadPasswordProtectedMediaModal
      ref="passwordModal"
      :mediaId="mediaId"
      :apiEndpoint="apiEndpoint"
      @download-success="handleDownloadSuccess"
      @download-error="handleDownloadError" />
  </div>
</template>

<script>
import downloadProtectedMedia from '../translations/downloadProtectedMedia';
import DownloadPasswordProtectedMediaModal from './DownloadPasswordProtectedMediaModal';

export default {
  name: 'DownloadPasswordProtectedMedia',
  components: {
    DownloadPasswordProtectedMediaModal,
  },
  props: {
    mediaId: {
      type: [String, Number],
      required: true,
    },
    apiEndpoint: {
      type: String,
      default: '/api/verify-password-download',
    },
  },
  emits: ['download-success', 'download-error'],
  data() {
    return {
      t: downloadProtectedMedia,
    };
  },
  methods: {
    openPasswordModal() {
      this.$refs.passwordModal?.openPasswordModal();
    },

    handleDownloadSuccess(data) {
      this.$emit('download-success', data);
    },

    handleDownloadError(error) {
      this.$emit('download-error', error);
    },
  },
};
</script>
